import { Segmented } from 'antd';
import { useTranslation } from 'react-i18next';

const LANGS = [
  { label: 'RU', value: 'ru' },
  { label: 'UZ', value: 'uz' },
  { label: 'EN', value: 'en' },
] as const;

type Props = {
  size?: 'small' | 'middle' | 'large';
};

export function LanguageSwitcher({ size = 'small' }: Props) {
  const { i18n } = useTranslation();
  const active = (i18n.resolvedLanguage ?? 'ru').slice(0, 2);

  return (
    <Segmented
      size={size}
      value={LANGS.find((l) => l.value === active)?.value ?? 'ru'}
      options={[...LANGS]}
      onChange={(v) => void i18n.changeLanguage(String(v))}
    />
  );
}
